import { render, staticRenderFns } from "./OtherHotTopics.vue?vue&type=template&id=45fc6310"
import script from "./OtherHotTopics.vue?vue&type=script&lang=ts"
export * from "./OtherHotTopics.vue?vue&type=script&lang=ts"
import style0 from "./OtherHotTopics.vue?vue&type=style&index=0&id=45fc6310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports